/* Product presentation only. Native Teeinblue inputs own all variants and customization. */
(() => {
  'use strict';
  const marker = document.querySelector('[data-np-reference-layout]');
  const dataNode = document.getElementById('np-reference-layout-data');
  const section = document.querySelector('[id^="MainProduct-"]');
  if (!marker || !dataNode || !section || dataNode.dataset.bound) return;
  dataNode.dataset.bound = 'true';
  let data;
  try { data = JSON.parse(dataNode.textContent); } catch { return; }
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: data.currency || 'USD', minimumFractionDigits: 2
  });
  let frame = 0;
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };
  function preparePacks() {
    const group = section.querySelector('.tee-option--size');
    if (!group) return;
    // Size labels such as S/M/L must remain native sizes, not pack offers.
    const packInputs = [...group.querySelectorAll('input')];
    if (!packInputs.length || !packInputs.every(input => /^\d+\s+PCS?$/i.test(input.value.trim()))) return;
    const title = group.querySelector('.tee-option__title');
    setText(title, 'Buy More Save More (Different Designs)');
    if (title && !title.id) title.id = 'np-reference-pack-title';
    group.querySelector('[role="radiogroup"]')?.setAttribute('aria-labelledby', title?.id || 'np-reference-pack-title');
    for (const radio of group.querySelectorAll('.tee-radio')) {
      const input = radio.querySelector('input');
      const label = radio.querySelector('label');
      if (!input || !label) continue;
      const variant = data.variants.find(item => item.options.includes(input.value));
      const count = parseInt(input.value, 10);
      if (!variant || !count) continue;
      let caption = label.querySelector('[data-np-unit-price]');
      if (!caption) {
        caption = document.createElement('small');
        caption.dataset.npUnitPrice = '';
        label.append(caption);
      }
      setText(caption, `${money.format(variant.price / count / 100)}/pc`);
      if (label.getAttribute('aria-label') !== `${input.value}, ${caption.textContent}`) {
        label.setAttribute('aria-label', `${input.value}, ${caption.textContent}`);
      }
    }
  }
  // Pick one column width for the entire group, including its longest label.
  // Keep native inputs intact; only adjust the presentation grid's minimum.
  const measureContext = document.createElement('canvas').getContext('2d');
  function prepareChoices() {
    if (!measureContext) return;
    for (const group of section.querySelectorAll('.product-form__input--pills, #tee-artwork-form .tee-row:has(>.tee-radio)')) {
      const labels = group.matches('.product-form__input--pills')
        ? group.querySelectorAll('input + label')
        : group.querySelectorAll(':scope > .tee-radio > label');
      let minimum = 96;
      for (const label of labels) {
        const style = getComputedStyle(label);
        measureContext.font = style.font;
        const inset = ['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth']
          .reduce((sum, key) => sum + (parseFloat(style[key]) || 0), 0);
        // Unavailable values carry screen-reader-only "sold out" text; size the grid by the visible label only.
        let text = label.innerText;
        for (const extra of label.querySelectorAll('.visually-hidden')) text = text.replace(extra.textContent.trim(), '');
        for (const line of text.split('\n')) {
          minimum = Math.max(minimum, Math.ceil(measureContext.measureText(line.trim()).width + inset + 4));
        }
      }
      // Long sentences get fewer, wider columns and can wrap at word boundaries.
      const value = `${Math.min(200, minimum)}px`;
      if (group.style.getPropertyValue('--np-choice-min') !== value) group.style.setProperty('--np-choice-min', value);
    }
  }
  function prepareGallery() {
    const wrapper = section.querySelector('.product__media-wrapper');
    if (!wrapper || !section.querySelector('#tee-artwork-form')) return;
    if (!wrapper.id) wrapper.id = 'np-reference-gallery';
    let tools = wrapper.querySelector('[data-np-reference-gallery-tools]');
    if (!tools) {
      tools = document.createElement('div');
      tools.className = 'np-reference-gallery-tools';
      tools.dataset.npReferenceGalleryTools = '';
      tools.setAttribute('role', 'group');
      tools.setAttribute('aria-label', 'Product image view');
      for (const [mode, text] of [['photos', 'Product photos'], ['preview', 'Your preview']]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.npReferenceView = mode;
        button.textContent = text;
        tools.append(button);
      }
      tools.addEventListener('click', event => {
        const mode = event.target.closest('[data-np-reference-view]')?.dataset.npReferenceView;
        if (mode === 'photos') {
          wrapper.classList.add('np-bakven-show-photo');
          if (wrapper.hasAttribute('data-np-pod-gallery')) wrapper.dataset.npPodGallery = 'photos';
          window.dispatchEvent(new Event('resize'));
        } else if (mode === 'preview') {
          wrapper.classList.remove('np-bakven-show-photo');
          if (wrapper.hasAttribute('data-np-pod-gallery')) wrapper.dataset.npPodGallery = 'live';
          window.dispatchEvent(new Event('resize'));
        }
        schedule();
      });
      wrapper.append(tools);
    }
    const isPhoto = wrapper.hasAttribute('data-np-pod-gallery')
      ? wrapper.dataset.npPodGallery === 'photos'
      : wrapper.classList.contains('np-bakven-show-photo');
    for (const button of tools.querySelectorAll('button')) {
      const pressed = button.dataset.npReferenceView === (isPhoto ? 'photos' : 'preview');
      if (button.getAttribute('aria-pressed') !== String(pressed)) button.setAttribute('aria-pressed', String(pressed));
    }
  }
  function prepareActions() {
    const preview = section.querySelector('#teeFormActions .tee-btn--preview');
    if (preview) setText(preview, 'Preview');
  }
  function refresh() { frame = 0; preparePacks(); prepareChoices(); prepareGallery(); prepareActions(); }
  function schedule() { if (!frame) frame = requestAnimationFrame(refresh); }
  const observer = new MutationObserver(schedule);
  observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-np-pod-gallery'] });
  section.addEventListener('change', schedule);
  section.addEventListener('input', schedule);
  document.addEventListener('teeinblue-component-injected', schedule);
  document.fonts.ready.then(schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('pagehide', () => { observer.disconnect(); window.removeEventListener('resize', schedule); cancelAnimationFrame(frame); }, { once: true });
  refresh();
})();

// Source98 only. The platform SDK can retain retired form click handlers after
// a Style change. Save the currently rendered, validated personalization using
// its official public customization endpoint, then use Shopify's normal cart.
(() => {
  const handle = 'np-xmas-9902580957467-custom-photo-funny-kids-christmas-light-personalized-pajama-pants-ak1340nah3985';
  const shop = 'afja3en.myshopify.com';
  const product = '15455756648747';
  const api = 'https://api.teeinblue.com/api/merchant/platform-products/';
  const inScope = () => [`/products/${handle}`, '/cart'].includes(location.pathname.replace(/\/$/, ''));
  if (!inScope()) return;
  const root = document.documentElement;
  if (root.dataset.npSource98AtcAdapter) return;
  root.dataset.npSource98AtcAdapter = '10';
  const selector = 'button[id^="ProductSubmitButton-"][name="add"][type="submit"]';
  const section = () => inScope() ? document.querySelector('[id^="MainProduct-"]') : null;
  const controller = new AbortController();
  let busy = false;
  let runtimePromise;
  let frame = 0;
  let lastForm;
  let lastButton;
  let cartOutcomeUnknown = false;
  const disabledButtons = new Map();
  const editRelays = new WeakSet();
  const pendingEdits = new WeakSet();
  let nativeEditPreparing = false;
  const visible = element => !!element?.getClientRects().length;
  const round = number => Math.round(number * 1e8) / 1e8;

  function showError(message) {
    const main = section();
    if (!main) return;
    let wrapper = main.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'product-form__error-message-wrapper';
      wrapper.setAttribute('role', 'alert');
      const text = document.createElement('span');
      text.className = 'product-form__error-message';
      wrapper.append(text);
      main.querySelector(selector)?.before(wrapper);
    }
    wrapper.hidden = !message;
    const text = wrapper.querySelector('.product-form__error-message');
    if (text) text.textContent = message || '';
  }

  function holdButton(button) {
    if (!button || disabledButtons.has(button)) return;
    disabledButtons.set(button, button.disabled);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
  }

  function syncForm() {
    frame = 0;
    const main = section();
    const button = main?.querySelector(selector);
    const form = button?.form;
    if (busy) holdButton(button);
    if (!runtimePromise && document.querySelector('svg[id*="1381971"], svg[id*="1381973"]')) getRuntime().catch(() => {});
    if (form === lastForm && button === lastButton) return;
    lastForm = form;
    lastButton = button;
    if (main) main.dataset.npSource98AtcAdapter = '10';
    if (form && button) document.dispatchEvent(new Event('teeinblue-event-clone-node'));
  }

  const observer = new MutationObserver(() => { if (!frame) frame = requestAnimationFrame(syncForm); });
  observer.observe(document.body, { childList: true, subtree: true });
  syncForm();

  async function getRuntime() {
    if (!runtimePromise) {
      runtimePromise = fetch(`${api}${product}.json?shop=${shop}&v=${Date.now()}`, {
        credentials: 'omit', cache: 'no-store', signal: controller.signal
      }).then(async response => {
        if (!response.ok) throw new Error('Your preview is still updating. Please try again.');
        const value = await response.json();
        if (value.id !== 141334 || String(value.platform_linked_id) !== product) throw new Error('Your preview is still updating. Please try again.');
        return value;
      }).catch(error => { runtimePromise = null; throw error; });
    }
    return runtimePromise;
  }

  function snapshot(form) {
    const main = section();
    const variant = form.querySelector('input[name="id"]')?.value;
    const quantityInput = form.elements.namedItem('quantity');
    const quantity = Number(quantityInput?.value || 1);
    if (!variant || !Number.isInteger(quantity) || quantity < 1 || quantityInput?.validity.valid === false) throw new Error('Please select an available size and quantity.');
    if ([...main.querySelectorAll('.tee-photo-uploading')].some(visible)) throw new Error('Please wait for your photos to finish processing.');
    const choices = Object.fromEntries([...main.querySelectorAll('.tee-field .tee-clipart.active input')].map(input => [input.name, input.value]));
    const confirmations = [...main.querySelectorAll('.tee-checkbox-wrapper')].filter(visible);
    const confirmed = confirmations.length > 0 && confirmations.every(box => box.querySelector('[role="checkbox"]')?.getAttribute('aria-checked') === 'true');
    const svgs = [...document.querySelectorAll('svg[id^="tee-artwork-"]')].filter(svg => /^tee-artwork-\d+$/.test(svg.id));
    const boards = svgs.map(svg => ({
      id: Number(svg.id.replace('tee-artwork-', '')),
      photos: [...svg.querySelectorAll('.tee-layer-group')].map(group => {
        const image = group.querySelector('.tee-layer-image image');
        const mask = group.querySelector(':scope > defs > mask');
        if (!image || !mask) return null;
        const transform = image.parentElement.getAttribute('transform') || '';
        const translate = transform.match(/translate\(\s*([-+.\deE]+)[,\s]+([-+.\deE]+)\s*\)/);
        const rotate = transform.match(/rotate\(\s*([-+.\deE]+)/);
        if (!translate) throw new Error('Your preview is still updating. Please try again.');
        const width = Number(mask.getAttribute('width'));
        const height = Number(mask.getAttribute('height'));
        return {
          layer: group.id.replace('artwork-layer--', ''),
          url: image.getAttribute('href') || image.getAttribute('xlink:href'),
          position: { w: round(Number(image.getAttribute('width')) / width), h: round(Number(image.getAttribute('height')) / height), x: round(Number(translate[1]) / width), y: round(Number(translate[2]) / height), a: Number(rotate?.[1] || 0), ratio: round(Number(image.getAttribute('width')) / Number(image.getAttribute('height'))) }
        };
      }).filter(Boolean)
    }));
    return { variant, quantity, choices, confirmations: confirmations.length, confirmed, boards };
  }

  function build(runtime, state) {
    const artwork = runtime.artworks.find(art => art.platform_variant_ids?.map(String).includes(state.variant));
    const board = state.boards.find(item => item.id === artwork?.id);
    const template = artwork?.data?.[0];
    if (!artwork || !board || !template) throw new Error('Please wait for your preview to finish updating.');
    if ((runtime.config?.confirmation_checkbox_enable || state.confirmations) && !state.confirmed) throw new Error('Please confirm your personalization before adding to cart.');
    const layers = Object.fromEntries(template.layers.map(layer => [layer.id, layer]));
    const data = {};
    const choice = id => {
      const option = layers[id]?.options?.find(item => item.id === state.choices[id]);
      if (!option) throw new Error('Please complete your personalization.');
      data[id] = option.id;
      return option;
    };
    choice('layer-710000');
    const count = Number(choice('layer-710001').name);
    if (!Number.isInteger(count) || count < 1 || count > 10) throw new Error('Please choose the number of people.');
    const globals = [];
    for (let person = 0; person < count; person++) {
      choice(`layer-${710002 + person * 2}`);
      globals.push(layers[`layer-${710003 + person * 2}`]?.global_option);
    }
    for (let person = 0; person < globals.length; person++) {
      const global = globals[person];
      const photos = board.photos.filter(photo => layers[layers[photo.layer]?.linked]?.global_option === global);
      if (!global || !photos.length || photos.some(photo => !/^https:\/\/cdnx\.teeinblue\.com\//.test(photo.url || '') || !photo.url.includes('/customers/uploads/'))) throw new Error(`Please upload a photo for person ${person + 1}.`);
      const first = photos[0];
      for (const photo of photos) {
        if (photo.url !== first.url || Object.keys(first.position).some(key => Math.abs(photo.position[key] - first.position[key]) > 1e-6)) throw new Error('Please wait for your preview to finish updating.');
      }
      if (Object.values(first.position).some(value => !Number.isFinite(value)) || first.position.w <= 0 || first.position.h <= 0) throw new Error('Please adjust your photo in the preview.');
      const nativeUrl = first.url.replace(/^https:\/\/cdnx\.teeinblue\.com\/ws\//, 'ws:');
      data[`global-option-${global}`] = nativeUrl;
      data[`global-option-${global}-data`] = { uploaded_history: [{ url: nativeUrl, originPath: null, customerUploadId: null }] };
      data[`global-option-${global}-position`] = first.position;
      // Retain the same current crop on global inputs, conditional helpers and
      // linked preview drawings. Native restore otherwise can retain a previous
      // per-layer position even when the saved global position is current.
      const globalOf = (layer, visited = new Set()) => {
        if (!layer || visited.has(layer.id)) return null;
        visited.add(layer.id);
        return layer.global_option || globalOf(layers[layer.linked], visited);
      };
      for (const layer of template.layers) {
        if (layer.type !== 'photo' || globalOf(layer) !== global) continue;
        data[layer.id] = nativeUrl;
        data[`${layer.id}-position`] = first.position;
        data[`${layer.id}-data`] = data[`global-option-${global}-data`];
      }
    }
    data[artwork.id] = template.id;
    data[`artwork-${artwork.id}`] = artwork.current_version_id;
    data.platform_linked_id = state.variant;
    return { data, artwork: artwork.id };
  }

  function refreshCartControls() {
    requestAnimationFrame(() => {
      if (controller.signal.aborted || !inScope()) return;
      document.dispatchEvent(new Event('shopify-event-cart-modified'));
      document.dispatchEvent(new Event('shopify-event-cart-updated'));
    });
  }

  function syncNativePhotoCache(data) {
    // The SDK normally keeps this personalization cache, independently of the
    // saved design. Its cart initializer gives the cache priority over that
    // design. Placement Save does not always refresh the global-option cache.
    // Update only this product's ten photo fields from the visible preview.
    try {
      const key = 'teeinblue-global-options';
      const existing = JSON.parse(localStorage.getItem(key) || '{}');
      if (!existing || typeof existing !== 'object' || Array.isArray(existing)) throw new Error('Invalid personalization cache');
      let changed = false;
      for (let id = 6247; id <= 6256; id++) {
        const prefix = `global-option-${id}`;
        if (!data[prefix] || !data[`${prefix}-position`]) continue;
        existing[id] = { value: data[prefix], extra: { ...(existing[id]?.extra || {}), data: data[`${prefix}-data`], position: data[`${prefix}-position`] }, timestamp: Date.now() };
        changed = true;
      }
      if (changed) localStorage.setItem(key, JSON.stringify(existing));
    } catch { throw new Error('Your browser could not keep your photo adjustments. Please enable site storage and try again.'); }
  }

  function cacheVisiblePhotoPositions() {
    const svgs = [...document.querySelectorAll('svg[id^="tee-artwork-"]')].filter(svg => /138197[13]/.test(svg.id) && visible(svg));
    const svg = svgs.find(item => item.id.includes('image-placement')) || svgs.find(item => item.id.includes('edit-customization')) || svgs[0];
    if (!svg) return Promise.resolve(null);
    const artId = Number(svg.id.match(/138197[13]/)?.[0]);
    const photos = [...svg.querySelectorAll('.tee-layer-group')].map(group => {
      const image = group.querySelector('.tee-layer-image image');
      const mask = group.querySelector(':scope > defs > mask');
      if (!image || !mask) return null;
      const url = image.getAttribute('href') || image.getAttribute('xlink:href');
      if (!url?.startsWith('https://cdnx.teeinblue.com/ws/customers/uploads/')) return null;
      const match = (image.parentElement.getAttribute('transform') || '').match(/translate\(\s*([-+.\deE]+)[,\s]+([-+.\deE]+)\s*\)/);
      if (!match) return null;
      const width = Number(mask.getAttribute('width')), height = Number(mask.getAttribute('height'));
      return { id: group.id.replace(/^(?:image-placement-)?artwork-layer--/, ''), url: url.replace('https://cdnx.teeinblue.com/ws/', 'ws:'), position: { w: round(Number(image.getAttribute('width')) / width), h: round(Number(image.getAttribute('height')) / height), x: round(Number(match[1]) / width), y: round(Number(match[2]) / height), a: Number((image.parentElement.getAttribute('transform') || '').match(/rotate\(\s*([-+.\deE]+)/)?.[1] || 0), ratio: round(Number(image.getAttribute('width')) / Number(image.getAttribute('height'))) } };
    }).filter(Boolean);
    return getRuntime().then(runtime => {
      const layers = Object.fromEntries((runtime.artworks.find(art => art.id === artId)?.data?.[0]?.layers || []).map(layer => [layer.id, layer]));
      const data = {};
      for (const photo of photos) {
        const layer = layers[photo.id];
        const id = layer?.global_option || layers[layer?.linked]?.global_option;
        if (!(id >= 6247 && id <= 6256) || Object.values(photo.position).some(value => !Number.isFinite(value))) continue;
        const prefix = `global-option-${id}`;
        data[prefix] = photo.url;
        data[`${prefix}-position`] = photo.position;
        data[`${prefix}-data`] = { uploaded_history: [{ url: photo.url, originPath: null, customerUploadId: null }] };
      }
      syncNativePhotoCache(data);
      return data;
    });
  }

  async function prepareNativeEdit(button, update) {
    let data;
    let expectedDesignId;
    if (update) data = await cacheVisiblePhotoPositions();
    else {
      const row = button.closest('.cart-item');
      const url = row?.querySelector('a[href*="/customizations/"]')?.getAttribute('href');
      const id = url?.match(/customizations\/([a-f\d-]{36})\.jpg/i)?.[1];
      if (!id) throw new Error('Your design is still loading. Please try again.');
      expectedDesignId = id;
      const response = await fetch(`https://api.teeinblue.com/api/merchant/shopify/customization/${id}?shop=${shop}`, { credentials: 'omit', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Could not open your design. Please try again.');
      const saved = await response.json();
      const runtime = await getRuntime();
      if (!runtime.artworks.some(art => art.platform_variant_ids.map(String).includes(String(saved.platform_variant_id)))) throw new Error('Could not open your design. Please try again.');
      data = saved.data;
    }
    if (!data) throw new Error('Your design is still loading. Please try again.');
    // Allow any already queued 500ms native cache write to finish, then restore
    // the selected cart line's own data. A second line never supplies its crop.
    await new Promise(resolve => setTimeout(resolve, 550));
    if (!button.isConnected || controller.signal.aborted) return false;
    if (expectedDesignId && !button.closest('.cart-item')?.querySelector(`a[href*="/customizations/${expectedDesignId}.jpg"]`)) throw new Error('Your cart changed. Please open your design again.');
    syncNativePhotoCache(data);
    editRelays.add(button);
    button.disabled = false;
    button.click();
    return true;
  }

  async function add(form) {
    const state = snapshot(form);
    const runtime = await getRuntime();
    const design = build(runtime, state);
    const unchanged = () => {
      if (section()?.querySelector(selector)?.form !== form || JSON.stringify(snapshot(form)) !== JSON.stringify(state)) throw new Error('Your personalization changed. Please review it and add to cart again.');
    };
    unchanged();
    syncNativePhotoCache(design.data);
    const save = await fetch(`${api}${product}/platform-customizations?shop=${shop}`, {
      method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ data: design.data, platform_variant_id: state.variant }), signal: controller.signal
    });
    if (!save.ok) throw new Error('Could not save your design. Please try again.');
    const result = await save.json();
    if (!/^[a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12}$/i.test(result.id || '')) throw new Error('Could not save your design. Please try again.');
    unchanged();
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer?.getSectionsToRender?.().map(item => item.id) || ['cart-drawer', 'cart-icon-bubble'];
    const request = {
      id: state.variant, quantity: state.quantity,
      properties: { _customization_id: result.id, _customization_image: `https://cdn.teeinblue.com/customizations/${result.id}.jpg`, _tib_design_link_1: `https://cdn.teeinblue.com/designs/${result.id}/${result.id}-${design.artwork}.png` },
      sections, sections_url: location.pathname
    };
    // The existing gift-box fetch adapter adds the selected gift exactly once.
    // No checkout, order or payment endpoint is involved.
    cartOutcomeUnknown = true;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(request), byTeeinblue: true, signal: controller.signal
    });
    const cart = await response.json();
    if (!response.ok || cart.status) { cartOutcomeUnknown = false; throw new Error(cart.description || 'Could not add your gift. Please check your cart before trying again.'); }
    syncNativePhotoCache(design.data);
    if (drawer?.renderContents && cart.sections) {
      drawer.classList.remove('is-empty');
      drawer.setActiveElement?.(document.activeElement);
      drawer.renderContents(cart);
      refreshCartControls();
    } else location.assign('/cart');
    root.dataset.npSource98SuccessfulAdds = String((Number(root.dataset.npSource98SuccessfulAdds) || 0) + 1);
    cartOutcomeUnknown = false;
  }

  document.addEventListener('click', event => {
    const action = event.target instanceof Element ? event.target.closest('button') : null;
    if (action && editRelays.has(action)) { editRelays.delete(action); return; }
    const update = action?.closest('.tee-edit-popup') && action.id === 'teeAtcButton' && action.closest('.tee-edit-popup').querySelector('svg[id*="1381971"],svg[id*="1381973"]');
    const edit = action?.classList.contains('tee-edit-button') && action.closest('.cart-item')?.querySelector(`a[href*="/products/${handle}"]`);
    if (action && (edit || update)) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (nativeEditPreparing || pendingEdits.has(action) || edit && [...document.querySelectorAll('.tee-edit-popup')].some(visible)) return;
      nativeEditPreparing = true;
      pendingEdits.add(action); action.disabled = true;
      prepareNativeEdit(action, !!update).then(replayed => { if (!replayed) action.disabled = false; }).catch(error => {
        action.disabled = false;
        const message = document.createElement('p'); message.setAttribute('role', 'alert'); message.textContent = error.message; action.after(message);
      }).finally(() => { pendingEdits.delete(action); nativeEditPreparing = false; });
      return;
    }
    if (action?.closest('.tee-dialog-image-placement') && action.textContent.trim() === 'Save') cacheVisiblePhotoPositions().catch(error => showError(error.message));
    const button = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!button || !section()?.contains(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (cartOutcomeUnknown) { location.assign('/cart'); return; }
    if (busy || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    busy = true;
    holdButton(button);
    showError('');
    add(button.form).catch(error => {
      if (!controller.signal.aborted) showError(error.message || 'Could not add your gift. Please check your cart before trying again.');
    }).finally(() => {
      busy = false;
      disabledButtons.forEach((wasDisabled, item) => {
        item.disabled = wasDisabled || item.dataset.unavailable === 'true';
        item.classList.remove('loading');
        item.removeAttribute('aria-busy');
      });
      disabledButtons.clear();
    });
  }, { capture: true, signal: controller.signal });

  window.addEventListener('pageshow', event => { if (event.persisted) { syncForm(); refreshCartControls(); } }, { signal: controller.signal });
  window.addEventListener('pagehide', event => {
    if (!event.persisted) { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); }
  }, { signal: controller.signal });
})();
